import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Camera Tool',
      href: '/en/Downloads/Desktop_Software/Instar_Camera_Tool/',
    },
    {
      text: 'InstarVision',
      href: '/en/Downloads/Desktop_Software/InstarVision/',
    },
    {
      text: 'InstarVision (macOS)',
      href: '/en/Downloads/Desktop_Software/InstarVision_for_macOS/',
    },
    {
      text: 'InstarVision (Metro)',
      href: '/en/Downloads/Desktop_Software/InstarVision_Metro/',
    },
    {
      text: 'Desktop Software',
      href: '/en/Downloads/Desktop_Software/',
    },
    {
      text: '◄ Downloads',
      href: '/en/Downloads/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Downloadbereich for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}